import parseUri from "parse-uri";

function assembleParsedUri(parser) {
  let result = `${parser.authority}${parser.directory}${parser.file}`;
  if (_.isString(parser.protocol) && parser.protocol.length > 0) {
    result = `${parser.protocol}://${result}`;
  }

  let query = _(parser.queryKey ? parser.queryKey : {})
    .map((value, key) => `${key}=${value}`)
    .join("&");
  if (_.isString(query) && query.length > 0) {
    result = `${result}?${query}`;
  }

  if (_.isString(parser.anchor) && parser.anchor.length > 0) {
    result = `${result}#${parser.anchor}`;
  }
  return result;
}

const Url = {
  getHostAddress(url) {
    let parser = parseUri(url);
    let result = parser.authority;
    if (_.isString(parser.protocol) && parser.protocol.length > 0) {
      result = `${parser.protocol}://${result}`;
    }
    return result;
  },

  getFilename(url) {
    let parser = parseUri(url);
    if (_.isString(parser.file) && parser.file.length === 0) {
      return parser.source;
    }
    return parser.file;
  },

  withAdditionalPath(url, path) {
    let parser = parseUri(url);
    if (!_.str.endsWith(parser.directory, "/")) {
      parser.directory += "/";
    }

    let sanitizedPath;
    if (path.startsWith("/")) {
      sanitizedPath = path.slice(1);
    } else {
      sanitizedPath = path;
    }

    parser.directory += sanitizedPath;
    return assembleParsedUri(parser);
  },

  withAdditionalParams(url, params) {
    let parser = parseUri(url);
    _.extend(parser.queryKey, params);
    return assembleParsedUri(parser);
  },

  withoutParams(url) {
    let parser = parseUri(url);
    parser.queryKey = {};
    return assembleParsedUri(parser);
  },

  expandTemplate(urlTemplate, params) {
    let href = urlTemplate.toString();
    _.each(params, (value, key) => {
      return (href = href.replace(`{${key}}`, encodeURIComponent(value)));
    });
    return href.replace(/{.*?}/g, "");
  },
};

export default Url;



// WEBPACK FOOTER //
// ./src/url.js